"use client";

import { useDiscoverContextProps } from "@/hooks/useDiscoverContextProps";
import { useTrackOnceConsented } from "@/hooks/useTrackOnceConsented";
import { getClubIdentityProps } from "@/lib/analytics/identity";

/**
 * Render inside a `<Suspense>` boundary: `useSearchParams` otherwise opts the
 * subtree out of static rendering.
 */
export function ClubViewTracker({
  clubId,
  isSpondClub,
  signupAvailable,
}: {
  clubId: string;
  isSpondClub: boolean;
  signupAvailable: boolean;
}) {
  const getContextProps = useDiscoverContextProps("clubs");

  useTrackOnceConsented(
    isSpondClub
      ? "discover_page__club_viewed"
      : "discover_page__external_club_viewed",
    () => ({
      ...getClubIdentityProps({ clubId, isSpondClub }),
      signup_available: signupAvailable,
      ...getContextProps(),
    }),
    { key: clubId },
  );

  return null;
}
